import { LIST } from '../actionTypes'

export const list = () => ({
  type: LIST.name,
  api: {
    url: 'guests/list',
    data: { is_joined_only: false },
  },
})
